import clsx from "clsx";
import * as React from "react";

interface BadgeProps extends React.ComponentPropsWithoutRef<"div"> {
  color?: "primary" | "gray" | "green" | "blue";
  count?: number;
  overflowCount?: number;
  dot?: boolean;
  classNames?: {
    root?: string;
    content?: string;
  };
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>((props, ref) => {
  const {
    className,
    children,
    color = "primary",
    count,
    dot,
    overflowCount,
    classNames,
    ...rest
  } = props;

  const hasText = !dot && count;
  const countToRender = () =>
    React.useMemo(() => {
      if (hasText && overflowCount && count > overflowCount) {
        return `${overflowCount}+`;
      }
      return count;
    }, [count, hasText, overflowCount]);

  return (
    <div
      ref={ref}
      data-color={color}
      className={clsx("ox-reset ox-Badge", className, classNames?.root)}
      {...rest}
    >
      {children ?? null}

      <span
        className={clsx("ox-reset ox-BadgeContent", classNames?.content)}
        data-positioned={Boolean(children)}
      >
        {countToRender()}
      </span>
    </div>
  );
});

Badge.displayName = "Badge";

export { Badge };
export type { BadgeProps };
